module.exports = __webpack_public_path__ + "static/media/heroinActive.d33afd46.svg";